export default __webpack_public_path__ + "static/meta_banner-59e6a2ca6e7513d101637a18f26bbbbb.webp";